import { useState } from 'react';
import { HubspotBrochureDownload, LeadgenCarousel  } from '.'

const LeadGenCampaign = (props) => {
    return (
        <>
        
        <section className="greyBackground sectionSpacing  pt-40">
          <div className="container customCampaignContainer">
            <div className="row d-flex align_items_center">
              <div className="wearbaleDevice col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div className="mainHeadingN ">Features at a glance</div>
                <div className="subHeading">
                  See what makes Vantage Fit the most effective corporate wellness platform
                </div>
              </div>
            </div>
          </div>
          <div className="container customCampaignContainer innerSpace campaignCarousel pt90" id="hrcarousel">
            <div className="row d-flex align_items_center">
              <div className="col-lg-12"><LeadgenCarousel/></div>
            </div>
          </div>
           <div className="container customCampaignContainer ">
            <div className="row d-flex align_items_center" >
              <div className="wearbaleDevice col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <p>Enjoy seamless integration between your wearable<br/> devices and Vantage Fit</p>
                <div className="wearableImages innerSpace">
                  <ul>
                    <li><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/fitbit.png" alt = "fitbit" className="lozad" loading ="lazy"/></li>
                    <li><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/applehealth.png" alt = "applehealth"  className="lozad" loading="lazy"/></li>
                    <li><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/iwatch.png" alt = "iwatch"  className="lozad" loading="lazy"/></li>
                    <li><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/gfit.png" alt = "gfit"  className="lozad" loading="lazy" /></li>
                    <li><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/garmin.png" alt = "garmin"  className="lozad" loading="lazy"/></li>
                    <li><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/sony.png" alt = "sony" className="lozad" loading="lazy"/></li>
                  </ul>
                </div>
                <div className="mt-10">And many more</div>
              </div>
            </div>
          </div>
        </section>
         <section className = "greyBackgroundN pt90">
          <div className=""><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/Seperator.png" alt="separator" className="lozad img-responsive" loading="lazy"/></div>
          <div className="container customCampaignContainer position innerSpace">
            <div className="row d-flex align_items_center" >
              <div className=" col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                <div className="mainHeading "><span>Ready to transform wellness in your organization?</span></div>
                <div className="mainHeadingN"> Schedule a free Demo now!</div>
                 <div className="col-lg-12 cta_center mt-60">
                     <a href="https://www.vantagefit.io/employee-wellness-program/#requestdemoForm" className="vfitcompanycta scrollToDownload"> Schedule a free demo </a> 
                  </div>
              </div>
            </div>
          </div>
        </section>
         <section className="sectionSpacing">
          <div className="container customContainer">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div className="mainHeadingN ">Easy and Intuitive HR Dashboard</div>
                <div className="subHeading">
                  Gain total control over your workplace wellness initiative with our easy-to-use admin dashboard.
                </div>
              </div>
            </div>
          </div>
          <div className="container customContainer innerSpace">
            <div className="row column-change ipadcolumn-change  d-flex align_items_center">
               <div className="col-lg-5 col-md-12 col-xs-12 col-sm-12">
                <div className="dashboardBox">
                  <div className="dashboardicon campaignSprite"></div>
                  <div className="dashboardTxt">
                    <div className="highlighter">
                      Simple Contest Creation and Management
                    </div>
                    <div>Create engaging contests in simple steps and manage every aspect with our highly intuitive admin panel. </div>
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="dashboardBox">
                  <div className="dashboardicon campaignSprite"></div>
                  <div className="dashboardTxt">
                    <div className="highlighter">
                      Advanced Analytics and Reports
                    </div>
                    <div>Gain detailed insights into your wellness campaigns to maximize employee engagement and participation.</div>
                  </div>
                  <div className="clearfix"></div>
                </div>
                <div className="dashboardBox">
                  <div className="dashboardicon campaignSprite"></div>
                  <div className="dashboardTxt">
                   <div className="highlighter">
                      Budget Management
                    </div>
                    <div>Allocate and manage the budget of your wellness campaign as per your organization’s requirements.</div>
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>
              <div className="col-lg-7 col-md-12 col-xs-12 col-sm-12">
                <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1605681397/VantageFit/landing_page/Dashboard_Snapshot.png" alt="dashboard" className="img-responsive lozad" loading="lazy"/>
               </div>
            </div>
          </div>
        </section>
        <section className="greyBackgroundN sectionSpacing position mtb-20">
          <div className="container customContainer">
            <div className="row" >
              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12 pclr  hidden-xs">
                <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/downloadappsnapshot.png" alt="downloadapp" className="fadeInupAnim downloadappFirst lozad" loading="lazy"/>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 ">
                <div className="mainHeadingN fadeInUp">Available in both android and iOS</div>
                <div className="subHeading">Download Vantage Fit today and build a healthy workforce
                </div>
                <div className="store-icons text-center">
                  <div className="app_downloadbanner index_download">
                     <div className=" transform button-style dwnload_app"> <a href="https://apps.apple.com/in/app/vantage-fit/id1393594182" target="_blank" rel="noopener"> 
                     <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_186/VantageFit/website/appstore.png" alt="ios" className="buildapp transform lozad" loading="lazy" /> </a> </div>
                     <div className=" transform button-style dwnload_app"> <a href="https://play.google.com/store/apps/details?id=com.bargaintechnologies.vantagefit.v_fit" target="_blank" rel="noopener"> <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_186/v1580904957/VantageFit/website/googleplay.png" alt="playstore" className="buildapp transform lozad" loading="lazy"/> </a> </div>
                  </div>
               </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12 pclr">
                 <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1606215958/VantageFit/NewWebsite/DownloadAppSnapsht.png" alt="downloadapp" className="fadeInupAnim downloadappSec lozad" loading="lazy" />
              </div>
            </div>
          </div>
        </section>
         <section className="sectionSpacing pb-0" id="requestdemoForm">
          <div className="container customContainer">
            <div className="row">
              <div className="col-md-8 filter_spc col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-12 col-lg-6 col-lg-offset-3 mx-auto">
                <div className="mainHeadingN fadeInUp">Schedule a free demo</div>
                <div className="subHeading">
                 Find out how Vantage Fit can help you create a culture of wellness in your workplace and build a more productive workforce
                
                 <div className="mt-10">Fill out the form to schedule a free demo tailored to your company's needs.</div>
                 <div id="formrequest" className="request-demo-form position innerSpace">
                   <HubspotBrochureDownload formID="10cf504b-eab3-410d-874c-b15e2a724bd8"/>
                   <div className="text-center demoformtext">We safeguard your personal information in accordance with our <a href="https://api.vantagecircle.com/vantagefit/api/v1/tnc/355?isPrivacy=true" target="_blank" className="company_color" rel="noopener">Privacy Policy</a></div>
              <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1591440496/VantageFit/website/Vfitpattern-1.png" alt="artwork" className="formbackground lozad" loading="lazy" />
               </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
         


        </>
    );
}

export default LeadGenCampaign;



